module.exports = __webpack_public_path__ + "static/headshot--casual-ebf8638918a07cd45d4eabadd1d936f0.jpeg";